import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Box,
  Theme,
} from "@material-ui/core";
import {
  NotificationTypeDto,
  NotificationSubject,
} from "../../../common/data/service-proxies";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  SimpleFormIterator,
  ArrayInput,
  useTranslate,
  FormDataConsumer,
} from "react-admin";
import { useTheme } from "@material-ui/styles";
import { NotificationEventTypeSelector } from "./NotificationEventTypeSelector";
import { SubjectEventTypesSummaryHandler } from "./SubjectEventTypesSummaryHandler";

interface Props {
  subject: NotificationSubject;
  eventTypes?: Array<NotificationTypeDto> | null;
}

export const EventTypesSubjectSelector = ({
  subject,
  eventTypes = [],
  ...props
}: Props) => {
  const theme: Theme = useTheme();
  const translate = useTranslate();
  const [selectedEventsCount, setSelectedEventsCount] = useState<number>(0);

  return (
    <Box>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography
            variant="body2"
            style={{ color: theme.palette.primary.main }}>
            {translate(
              `resources.admin-notifications.notificationTypes.${subject}.name`,
              { _: subject }
            )}{" "}
            ({selectedEventsCount}/{eventTypes?.length})
          </Typography>
        </AccordionSummary>
        <AccordionDetails className="ra-input form-accordion">
          <ArrayInput
            {...props}
            source={`eventPreferences.${subject}`}
            label="">
            <SimpleFormIterator
              disableAdd={selectedEventsCount === eventTypes?.length}>
              <FormDataConsumer>
                {(formDataProps) => {
                  formDataProps.getSource && formDataProps.getSource("");
                  return (
                    <NotificationEventTypeSelector
                      eventTypes={eventTypes}
                      subject={subject}
                      {...formDataProps}
                    />
                  );
                }}
              </FormDataConsumer>
            </SimpleFormIterator>
          </ArrayInput>
        </AccordionDetails>
      </Accordion>
      <FormDataConsumer>
        {(props) => (
          <SubjectEventTypesSummaryHandler
            onSelectedEventsCountChanged={setSelectedEventsCount}
            subject={subject}
            {...props}
          />
        )}
      </FormDataConsumer>
    </Box>
  );
};
